const Editor = {
  create($modal) {
    this.dragging = false;

    this.$focalEditor = $modal.find('.js-focal-wrap');
    this.$focalPoint = this.$focalEditor.find('.js-focal-point');
    this.$focalPointX = $modal.find('.js-focal-point-x');
    this.$focalPointY = $modal.find('.js-focal-point-y');

    this.$focalPointX.add(this.$focalPointY).on('change keyup', () => {
      const bound = val => this.keepInBoundaries(val, 0, 100);
      const x = bound(parseInt(this.$focalPointX.val(), 10));
      const y = bound(parseInt(this.$focalPointY.val(), 10));

      if (!Number.isNaN(x) && !Number.isNaN(y)) {
        this.movePointTo(x, y);
      }
    });

    this.$focalEditor.on('mousedown', '.js-focal-point', () => {
      this.dragging = true;
    });

    this.$focalEditor.on('mousemove', (e) => {
      if (this.dragging) {
        const editorWidth = this.$focalEditor.width();
        const editorHeight = this.$focalEditor.height();
        const { left, top } = this.$focalEditor.offset();

        const relX = e.pageX - left;
        const relY = e.pageY - top;

        const x = this.keepInBoundaries(relX / editorWidth) * 100;
        const y = this.keepInBoundaries(relY / editorHeight) * 100;

        this.movePointTo(x, y);
      }
    });

    this.$focalEditor.on('mouseup', '.js-focal-point', () => {
      this.dragging = false;
    });
  },

  keepInBoundaries(num, min = 0, max = 1) {
    if (num < min) { return min; }
    if (num > max) { return max; }
    return num;
  },

  movePointTo(x, y) {
    this.$focalPoint.css({
      top: `${y}%`,
      left: `${x}%`,
    });

    this.$focalPointX.val(Math.round(x));
    this.$focalPointY.val(Math.round(y));
  },

  destroy() {

  },
};

export default Editor;
